module.exports = __webpack_public_path__ + "static/italic-817d4a95e5b04b5f4f910772a3d5910a.woff2";